import * as actions from "../actions/window";
import { setSafe } from "../util/storeHelper";
/**
 * reducer for changes to the window state
 */
export const windowReducer = {
    reducers: {
        [actions.setWindowSize]: (state, payload) => setSafe(state, ["size"], payload),
        [actions.setWindowPosition]: (state, payload) => setSafe(state, ["position"], payload),
        [actions.setMaximized]: (state, payload) => setSafe(state, ["maximized"], payload),
        [actions.setZoomFactor]: (state, payload) => setSafe(state, ["zoomFactor"], payload),
        [actions.setTabsMinimized]: (state, payload) => setSafe(state, ["tabsMinimized"], payload),
        [actions.setCustomTitlebar]: (state, payload) => setSafe(state, ["customTitlebar"], payload),
        [actions.setUseModernLayout]: (state, payload) => setSafe(state, ["useModernLayout"], payload),
    },
    defaults: {
        maximized: false,
        zoomFactor: 1.0,
        position: { x: 0, y: 0 },
        size: {},
        tabsMinimized: false,
        customTitlebar: true,
        useModernLayout: true,
    },
};
